const COLORS_LIMIT = 6;

export default {
    COLORS_LIMIT,
};
